import { useTimer } from "react-timer-hook";

const ActivationTimer = ({ expiryTimestamp }) => {
  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    resume,
    restart,
  } = useTimer({
    expiryTimestamp,
    onExpire: () => console.warn("onExpire called"),
  });

  return (
    <>
      <span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span>
    </>
  );
};
export default ActivationTimer;
